import React from "react";
import { Typography } from "@material-ui/core";
import { useStyles } from "styling/mainStyles";

const PrivacyText = () => {
  const classes = useStyles();

  return (
    <div className={classes.infoContent}>
      <p>
        <b>Последна промяна: 30 Дек, 2020</b>
      </p>

      <p>
        Мобилното приложение My Daily Budget е безплатно и се поддържа само от
        реклами.
      </p>

      <p>
        Тази страница има за цел да информира относно събирането, използването и
        разкриването на лична информация на потребителите на приложението.
      </p>

      <p>
        Ако решите да ползвате това приложение, трябва да приемете събирането и
        изпловането на информация във връзка с приложението. Личната информация,
        която се събира се използва само и единствено за подобряване на
        услугата. Вашата информация няма да бъде ползвана или споделяна с
        никого, освен в случаите, описани в тези условия за поверителност.
      </p>

      <Typography variant="h5">Събиране и използване на информация</Typography>

      <p>
        Приложението използва Facebook Login услугата за идентификация и
        вписване на сворите потребители. Информацията, която се пази от тази
        услуга е <b>имейл адрес</b> и <b>id</b> на потребителя, които се
        предоставят от Facebook след ваше съгласие. Тези данни се използват само
        и единствено за съдаване на профил на потребителя и вписване в
        приложението и не се предоставят на трети страни, както и не се ползват
        за маркетингови цели.
      </p>

      <p>
        Всеки потребител може да изтрие всички данни, които MyDailyBudget пази
        за него по всяко време. За повече информация, посетете раздел{" "}
        <a href="https://mydailybudget.com/data-deletion">
          "изтриване на данни"
        </a>
      </p>

      <p>
        Приложението използва и други услуги на трети страни, които могат да
        събират информация, използвана за идентифициране.
      </p>

      <p>
        Връзка към политиката за поверителност на доставчици на услуги на трети
        страни, използвани от приложението:
      </p>

      <ul>
        <li>
          <a
            href="https://www.google.com/policies/privacy/"
            target="_blank"
            rel="noopener"
            rel="noreferrer"
          >
            Google Play Services
          </a>
        </li>
        <li>
          <a
            href="https://support.google.com/admob/answer/6128543?hl=en"
            target="_blank"
            rel="noopener"
            rel="noreferrer"
          >
            Google AdMob
          </a>
        </li>
        {/* <li>
          <a
            href="https://firebase.google.com/policies/analytics"
            target="_blank"
          >
            Firebase Analytics
          </a>
        </li> */}
      </ul>

      <p>
        Моля да бъдете информирани, че всеки път, когато изполвате приложението,
        в случай на възникнала грешка, събираме данни и информация (чрез
        продукти на трети страни) на телефона ви, наречени Log Data. Тези данни
        могат та включват информация като IP адрес на устройството, името на
        устройството, версията на операционната система, конфигурацията на
        приложението при ползване на услугата, времето и датата на ползване на
        приложението и друга статистика.
      </p>

      <Typography variant="h5">Бисквитки</Typography>

      <p>
        Бисквитките са файлове с малко количество данни, които обикновено се
        използват като анонимни уникални идентификатори. Те се изпращат до
        браузъра ви от посещаваните от вас уебсайтове и се съхраняват във
        вътрешната памет на устройството ви.
      </p>

      <p>
        Това приложение не използва тези бисквитки, но е възножно услугите,
        които приложението ползва от трети страни, изброени по-горе, да ползват
        бисквитки, за да събират информация и да подобряват своите услуги.
      </p>

      {/* <h2>Връзки към други сайтове</h2>

      <p>
        Тази услуга може да съдържа връзки към други сайтове, както и външни
        връзки към радио стриймове. Ние нямаме контол върху съдържанието на тези
        сайтове и стриймове и не носим отговорност при евентуално нарушение на
        авторски права или ползване на вулгарен език, както и пропвядване на
        насилие от тяхна страна.
      </p> */}

      <Typography variant="h5">Поверителност при деца</Typography>

      <p>Това приложение не е предназначено за лица под 13-годишна възраст.</p>

      <Typography variant="h5">
        Промени в тези условия за поверителност
      </Typography>

      <p>
        Възможни са актуализации на тези условия за поверителност. Ако тази
        актуализация променя условията за поверителност на вашата информация, ще
        бътете информирани чрез приложението, след като промяната бъде
        публикувана на тази страница.
      </p>

      <Typography variant="h5">Контакт</Typography>

      <p>
        Ако имате някакви въпроси или предложеня, винаги може да ги споделите на
        admin[кльомба]mydailybudget[точка]com
      </p>
    </div>
  );
};

export default PrivacyText;
